import { ApiSmpPage, IApiSmpPage } from "@smp/api";
import { UiBox, UiTypography } from "@smp/ui";
import { useQuery } from "react-query";

import { AvatarSocial } from "@/components/ui/avatar_social";

export const Page = ({
  externalId,
  medium,
}: {
  externalId: IApiSmpPage["external_id"];
  medium: IApiSmpPage["medium"];
}) => {
  const { data: page } = useQuery(
    [
      "smp.page",
      {
        external_id: externalId,
        medium,
      },
    ],
    () =>
      ApiSmpPage.retrieveByExternalId({
        path: { medium__external_id: `${medium}:${externalId}` },
      }),
  );

  return page ? (
    <UiBox
      alignItems="center"
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
    >
      <UiBox marginRight={2}>
        <AvatarSocial
          medium={page.medium}
          src={page.extra_data.logo || undefined}
        />
      </UiBox>
      <UiBox overflow="hidden">
        <UiTypography overflow="hidden" textOverflow="ellipsis">
          {page.name}
        </UiTypography>
      </UiBox>
    </UiBox>
  ) : null;
};
